<<template>
    <div>
         <!-- ====== Team Start ====== -->
    <section id="team" class="ch-gw-team" style="padding-top: 1rem;">
      <div class="container m_container ch-gw-animation">
        <div class="row">
          <div class="col-lg-12" >
            <a v-for="(item,index) in newsList" :href="item.newsUrl" style="width: 100%;" class="">
                <div style="border-bottom: 1px solid rgba(0,0,0,0.1);display: flex;flex-wrap: nowrap;align-items: center;justify-content: space-between;width: 100%;padding-bottom: 2rem;padding-top: 2rem;">
                    <div class="gw_news_dynamic_img" >
                        <div class="newsImg" style="width: 100%;height: 100%;">
                            <el-image
                                style="width: 100%; height: 100%"
                                :src="item.newsImag"
                                fit="fill">
                                </el-image>
                        </div>
                    </div>
                    <div class="gw_news_dynamic_text" >
                        <p class="newsTitle">
                            {{ item.newsName }}
                        </p>
                        <p style="font-size: 0.8rem;padding-top: 0.5rem;">
                            2022-05-21
                        </p>
                        <p class="newsTitleVice" >
                            {{ item.newsViceName }}
                        </p>
                        <p class="gw_news_dynamic">
                            查看详情
                        </p>
                    </div>
                </div>
            </a>
          </div>
        </div>
      </div>
    </section>
    <div style="width: 100%;display: flex;justify-content: center;padding-bottom: 2rem;">
            <el-pagination
                background
                layout="prev, pager, next"
                :page-size="pageSize"
                :total="pageCount"
                @current-change="pagesChange">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import {queryNews } from "@/utils/gw";
export default {
  components:{

  },
  name: 'news',
  data () {
    return {
        pageIndex:1,
        pageCount:0,
        pageSize:0,
        newsList:[],
    }
  },
  mounted() {
    this.queryNews();
  },
  methods:{
    pagesChange(v){
        console.log(v)
        this.pageIndex = v
        this.queryPatent()
    },
    queryNews(){
        var u = "?pageIndex="+this.pageIndex
        queryNews(u).then((e)=>{
            this.pageCount =  e.data.pageCount
            this.pageSize = e.data.pageSize
            this.newsList = e.data.news
            console.log(e.data.news)
        })
      },
  }
}
</script>
<style>
    .newsImg{
        transition: 0.3s; 
        width: 100%;
        height: 100%;
    }
    .newsImg:hover {
        transition: 0.3s;
        transform: scale(1.1);
    }
    
</style>



// WEBPACK FOOTER //
// src/components/about/news.vue